import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";

@Injectable()
export class AnnotationvariantService {
  env: any = environment;

  constructor(private http: HttpClient) {}

  createAnnotationvariant(annotationvariant) {
    return new Promise((resolve, reject) => {
      this.http
        .post<any>(
          this.env.managirUrl + "/annotationvariants",
          annotationvariant,
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .toPromise()
        .then((response) => {
          console.log(response);
          resolve(response.AnnotationvariantResponse.annotationvariants[0]);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  updateAnnotationvariant(annotationvariant) {
    // console.log("update aufgerufen" + annotationvariant);
    return new Promise((resolve, reject) => {
      this.http
        .put<any>(
          this.env.managirUrl + "/annotationvariants/" + annotationvariant._id,
          annotationvariant,
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .toPromise()
        .then((response) => {
          resolve(response.message);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  deleteAnnotationvariantById(annotationvariantId) {
    return new Promise((resolve, reject) => {
      this.http
        .delete<any>(
          this.env.managirUrl + "/annotationvariants/" + annotationvariantId,
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .toPromise()
        .then((response) => {
          resolve(response.message);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }
}



// WEBPACK FOOTER //
// /agir/src/app/services/annotationvariant/annotationvariant.service.ts